<template>
	<div class="form-group">
		<h2 style="white-space: pre-wrap;">{{ field.text }}</h2>
	</div>
</template>

<script>
export default {
	props: ['field']
};
</script>
